import { connect, MapDispatchToProps } from "react-redux";
import {
  completedSLPListPDFRequest,
  completedSLPListRequest,
  plaUserListRequest,
  slpRequestsPDFRequest,
  slpRequestsRequest,
  updateSLPContactNoteRequest,
  updateSLPParticipationRequest,
} from "store/slpDashboard/actions";
import {
  ISLPDashboardContainerDispatch,
  ISLPRequest,
} from "utils/interfaces/slp";
import {
  allocatePLARequest,
  deferSLPRequest,
  updateContactDateRequest,
} from "store/studentProfileDetails/actions";
import SLPDashboardComponent, { SLPDashboardProps } from ".";

const mapDispatchToProps: MapDispatchToProps<
  ISLPDashboardContainerDispatch,
  ISLPRequest
> = {
  slpRequestsRequest,
  slpRequestsPDFRequest,
  plaUserListRequest,
  // updateSLPContactProgressRequest,
  completedSLPListRequest,
  completedSLPListPDFRequest,
  updateSLPParticipationRequest,
  updateSLPContactNoteRequest,
  allocatePLARequest,
  updateContactDateRequest,
  deferSLPRequest,
};

const connector = connect(null, mapDispatchToProps);

const SLPDashboard: React.FC<SLPDashboardProps> = (props) => {
  return <SLPDashboardComponent {...props} />;
};

export default connector(SLPDashboard);
